import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../_helper/api_helper";
import { toast } from "react-toastify";

const ADD_ROLE_PAYROLL_EMPLOYEE = "Payroll/AddSupervisorEmployee";
const UNASSIGN_PAYROLL_EMPLOYEE = "Payroll/RemoveSupervisorEmployee";
const GET_SUPERVISOR_DETAILS_BY_ID = "Payroll/GetSupervisorDetailById";
const ADD_UPDATE_ALL_PAYROLL_EMPLOYEE = "Payroll/AddUpdateAllSupervisorEmployee"
const UNASSIGN_ALL_PAYROLL_EMPLOYEE = "Payroll/RemoveAllSupervisorEmployee"
const ASSIGN_EMPLOYEE_TO_SUPERVISOR = 'Payroll/AssignEmployeeToSupervisor'
const sliceName = "PayrollEmployee";

export const AddSupervisorAndTimekeeperRole = createAsyncThunk(
    ADD_ROLE_PAYROLL_EMPLOYEE,
    async (payload) => {
        try {
            let response = await post(`${process.env.REACT_APP_WEB_API_URL}${ADD_ROLE_PAYROLL_EMPLOYEE}`, payload);
            toast.success(response?.message);
            return { addRole: response };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const AssignEmployeeToSupervisor = createAsyncThunk(
    ASSIGN_EMPLOYEE_TO_SUPERVISOR,
    async (payload) => {
        try {
            let response = await post(`${process.env.REACT_APP_WEB_API_URL}${ASSIGN_EMPLOYEE_TO_SUPERVISOR}`, payload);
            toast.success(response?.message);
            return { response: response };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const AddUpdateAllSupervisorAndTimekeeperRole = createAsyncThunk(
    ADD_UPDATE_ALL_PAYROLL_EMPLOYEE,
    async (payload) => {
        try {
            let response = await post(`${process.env.REACT_APP_WEB_API_URL}${ADD_UPDATE_ALL_PAYROLL_EMPLOYEE}`, payload);
            toast.success(response?.message);
            return { addRole: response };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const UnassignSupervisorEmployee = createAsyncThunk(
    UNASSIGN_PAYROLL_EMPLOYEE,
    async (payload) => {
        try {
            let response = await post(`${process.env.REACT_APP_WEB_API_URL}${UNASSIGN_PAYROLL_EMPLOYEE}`, payload);
            toast.success(response?.message);
            return { response: response };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const UnassignAllSupervisorEmployee = createAsyncThunk(
    UNASSIGN_ALL_PAYROLL_EMPLOYEE,
    async (payload) => {
        try {
            const response = await post(`${process.env.REACT_APP_WEB_API_URL}${UNASSIGN_ALL_PAYROLL_EMPLOYEE}?supervisorId=${payload.supervisorId}`, payload);
            toast.success(response?.message);
            return { response: response };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const GetSupervisorDetailsByID = createAsyncThunk(
    GET_SUPERVISOR_DETAILS_BY_ID,
    async (payload) => {
        try {
            let response = await get(`${process.env.REACT_APP_WEB_API_URL}${GET_SUPERVISOR_DETAILS_BY_ID}?id=${payload}`);
            return { supervisorObject: response?.data };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const resetPayrollEmployee = createAsyncThunk('resetPayrollEmployee', async () => {
    return {}
});

const PayrollEmployeeSlice = createSlice({
    name: sliceName,
    initialState: {
        addRole: {},
        isAddingRole: false,
        addRoleError: {},
        error: {},
        response: {},
        isUnassigningEmployee: false,
        supervisorObject: {},
        isFetchingSupervisorDetails: false
    },
    extraReducers: (builder) => {
        builder
            .addCase(AddSupervisorAndTimekeeperRole.pending, (state) => { state.isAddingRole = true; })
            .addCase(AddSupervisorAndTimekeeperRole.fulfilled, (state, action) => {
                state.addRole = action.payload?.addRole;
                state.isAddingRole = false;
            })
            .addCase(AddSupervisorAndTimekeeperRole.rejected, (state, action) => {
                state.addRole = {};
                state.addRoleError = action.payload?.error;
                state.isAddingRole = false;
            })
            .addCase(AssignEmployeeToSupervisor.pending, (state) => { state.isAddingRole = true; })
            .addCase(AssignEmployeeToSupervisor.fulfilled, (state, action) => {
                state.addRole = action.payload?.response;
                state.isAddingRole = false;
            })
            .addCase(AssignEmployeeToSupervisor.rejected, (state, action) => {
                state.addRole = {};
                state.addRoleError = action.payload?.error;
                state.isAddingRole = false;
            })
            .addCase(AddUpdateAllSupervisorAndTimekeeperRole.pending, (state) => { state.isAddingRole = true; })
            .addCase(AddUpdateAllSupervisorAndTimekeeperRole.fulfilled, (state, action) => {
                state.addRole = action.payload?.addRole;
                state.isAddingRole = false;
            })
            .addCase(AddUpdateAllSupervisorAndTimekeeperRole.rejected, (state, action) => {
                state.addRole = {};
                state.addRoleError = action.payload?.error;
                state.isAddingRole = false;
            })
            .addCase(UnassignSupervisorEmployee.pending, (state) => { state.isUnassigningEmployee = true; })
            .addCase(UnassignSupervisorEmployee.fulfilled, (state, action) => {
                state.response = action.payload?.response;
                state.isUnassigningEmployee = false;
            })
            .addCase(UnassignSupervisorEmployee.rejected, (state, action) => {
                state.response = {};
                state.error = action.payload?.error;
                state.isUnassigningEmployee = false;
            })
            .addCase(UnassignAllSupervisorEmployee.pending, (state) => { state.isUnassigningEmployee = true; })
            .addCase(UnassignAllSupervisorEmployee.fulfilled, (state, action) => {
                state.response = action.payload?.response;
                state.isUnassigningEmployee = false;
            })
            .addCase(UnassignAllSupervisorEmployee.rejected, (state, action) => {
                state.response = {};
                state.error = action.payload?.error;
                state.isUnassigningEmployee = false;
            })
            .addCase(GetSupervisorDetailsByID.pending, (state) => { state.isFetchingSupervisorDetails = true; })
            .addCase(GetSupervisorDetailsByID.fulfilled, (state, action) => {
                state.supervisorObject = action.payload?.supervisorObject;
                state.isFetchingSupervisorDetails = false;
            })
            .addCase(GetSupervisorDetailsByID.rejected, (state, action) => {
                state.supervisorObject = {};
                state.isFetchingSupervisorDetails = false;
            })
            .addCase(resetPayrollEmployee.fulfilled, (state, action) => {
                state.response = {};
                state.addRole = {};
            });
    },
});
export default PayrollEmployeeSlice.reducer;
